module.exports = __webpack_public_path__ + "img/lock_bild.669459fb.jpg";